<!-- ###################  ADD frontline winning grid div  ################### -->

<div>
    <div
        class="container-fluid"
        style="text-align: left"
    >
        <div class="badge-legend nogutter mb-2">
            <div class="utilities-buttons"></div>
        </div>
        <div
            *ngIf="_tempFlWinningData?.hasData == true"
            class="table-coaching-insight-content-sec"
        >
            <!-- ###################  ADD frontline winning grid div  ################### -->
            <table
                stickyTableContainer
                class="table coaching-insight-content"
                [ngClass]="{
                    'more-metrics-opened':
                        moreOAMetricsOpened === true ||
                        moreNonOAMetricsOpened === true
                }"
                *ngIf="columns | async as cols"
            >
                <colgroup>
                    <ng-container *ngFor="let th of cols; let i = index">
                        <col
                            [ngStyle]="th.colstyle"
                            [ngClass]="th.colclass"
                            *ngIf="th.active == true"
                        />
                    </ng-container>
                </colgroup>

                <thead>
                    <tr
                        #thConatiner
                        stickyTableHeaderRow
                    >
                        <ng-container *ngFor="let th of cols; let i = index">
                            <th
                                stickyTableHeader
                                [ngStyle]="th.styles"
                                class="team-floa-header"
                                [ngClass]="th.class"
                                *ngIf="th.active == true"
                            >
                                <div class="floa-header">
                                    <div
                                        *ngIf="th.left"
                                        [ngClass]="th.left.class"
                                        [innerHTML]="th.left.content"
                                    ></div>

                                    <div
                                        class="team-oa-header-item"
                                        [ngClass]="th.classes"
                                    >
                                        <div
                                            class="header-content"
                                            [ngClass]="th.headerContentClass"
                                            [innerHTML]="th.header"
                                        ></div>

                                        <ng-container
                                            *ngFor="let icon of th.icon"
                                        >
                                            <div
                                                class="team-oa-header-icon-container"
                                            >
                                                <cmps-icon
                                                    class="cmps-cdk-cursor-pointer"
                                                    [svgIcon]="
                                                        icon.class[icon.counter]
                                                    "
                                                    (click)="
                                                        toggle(
                                                            $event,
                                                            icon,
                                                            cols
                                                        )
                                                    "
                                                    *ngIf="
                                                        icon &&
                                                        icon.state !== undefined
                                                    "
                                                ></cmps-icon>
                                            </div>
                                        </ng-container>
                                    </div>

                                    <div
                                        *ngIf="th.right"
                                        [ngClass]="th.right.class"
                                        [innerHTML]="th.right.content"
                                    ></div>
                                </div>
                            </th>
                        </ng-container>
                    </tr>
                </thead>

                <tbody class="coaching-insight-metrics-sec">
                    <!-- New -->
                    <ng-container *ngIf="_tempFlWinningData">
                        <ng-content
                            *ngTemplateOutlet="
                                frontlineRowHierarchy;
                                context: {
                                    rowdata: getFlWinningData(
                                        1,
                                        _tempFlWinningData
                                    )
                                }
                            "
                        ></ng-content>
                    </ng-container>
                    <!-- templates -->

                    <ng-template
                        #frontlineRowHierarchy
                        let-rowdata="rowdata"
                    >
                        <tr
                            frontlineWinningPersonRow
                            [periodTypeId]="periodTypeId"
                            [periodTypeDate]="periodTypeDate"
                            [ngClass]="rowdata.levelClass"
                            [FLWinningPerson]="rowdata"
                            [maxUncoached]="rowdata.maxUncoached"
                            [maxCoached]="rowdata.maxCoached"
                            (selectedUserChange)="
                                selectedUserChange.emit($event)
                            "
                            (collapsed)="checkIfAllCollapsed()"
                            (receivedSubordinates)="
                                appendSubordinates($event, rowdata)
                            "
                            (receivedMetrics)="appendMetrics($event, rowdata)"
                        ></tr>

                        <ng-container
                            *ngIf="rowdata.subOrdinates && rowdata.isExpanded"
                        >
                            <ng-container
                                *ngFor="let subdata of rowdata.subOrdinates"
                            >
                                <ng-content
                                    *ngTemplateOutlet="
                                        frontlineRowHierarchy;
                                        context: {
                                            rowdata: getFlWinningData(
                                                rowdata.level + 1,
                                                subdata
                                            )
                                        }
                                    "
                                ></ng-content>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>
